import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToTransformYourFuture() {
  return <section data-section-id="222956" id="your-custom-home-list" className="relative w-full dark bg-background py-40 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-5xl mx-auto relative z-10">
        {}
        <div className="relative rounded-3xl p-[2px] overflow-hidden shadow-2xl shadow-primary/20">
          
          {}
          <div className="absolute inset-[-100%] animate-[spin_4s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,transparent_0%,var(--color-primary)_50%,transparent_100%)] opacity-70" />
          
          {}
          <div className="relative bg-slate-900 rounded-2xl px-6 py-24 md:py-32 flex flex-col items-center justify-center overflow-hidden text-center">
            
            {}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-20 pointer-events-none" />
            
            {}
            <h2 className="text-5xl md:text-7xl font-default font-bold text-white tracking-tight mb-10 relative z-10 leading-tight">
              Ready to find your $650K dream home?
            </h2>
            
            <Button asChild size="lg" className="relative z-10 h-16 px-12 text-xl font-default rounded-full bg-primary hover:bg-primary/90 text-primary-foreground border-0 shadow-[0_0_40px_-10px_var(--color-primary)] transition-all duration-300 hover:scale-105">
              <Link to="#">Send Me Homes Under $650K</Link>
            </Button>

          </div>
        </div>
      </div>
    </section>;
}